module.exports = __webpack_public_path__ + "img/8eeb5f06003e1f727213ae680e41dd78.png";